"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var VoipCart_1 = require("./VoipCart");
exports.default = VoipCart_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CartLob/VoipCart/index.js
// module id = 785
// module chunks = 8